import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  input,
  Type,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import {PendingTasks} from '@angular/core';
import {
  UmpireComponentTypeEnum,
  HomePageTemplateComponent,
  TicketPageTemplateComponent,
  OttPageTemplateComponent,
  UmpireComponentType,
  UmpireComponent,
} from '@tisa-group/models';

export type ClientComponent = any;

export const CLIENT_COMPONENT_MAP = new Map<
  UmpireComponentTypeEnum,
  () => Promise<Type<ClientComponent>>
>([
  [
    UmpireComponentTypeEnum.HERO_MAIN,
    () =>
      import('@tisa-group/client-ui/components/hero-main-articles').then(
        m => m.HeroMainArticlesComponent,
      ),
  ],
  [
    UmpireComponentTypeEnum.NEWS,
    () => import('@tisa-group/client-ui/components/news').then(m => m.NewsComponent),
  ],
  [
    UmpireComponentTypeEnum.TEXT,
    () => import('@tisa-group/client-ui/components/text').then(m => m.TextComponent),
  ],
  [
    UmpireComponentTypeEnum.OTT_FORMAT,
    () =>
      import('@tisa-group/client-ui/components/ott-list').then(m => m.OttListComponent),
  ],
  [
    UmpireComponentTypeEnum.OTT_FORMAT_LIST,
    () =>
      import('@tisa-group/client-ui/components/ott-list').then(m => m.OttListComponent),
  ],
  [
    UmpireComponentTypeEnum.OTT_PLAYLIST,
    () =>
      import('@tisa-group/client-ui/components/ott-list').then(m => m.OttListComponent),
  ],
  [
    UmpireComponentTypeEnum.OTT_PLAYLIST_LIST,
    () =>
      import('@tisa-group/client-ui/components/ott-list').then(m => m.OttListComponent),
  ],
  [
    UmpireComponentTypeEnum.HERO_THEMATIC,
    () =>
      import('@tisa-group/client-ui/components/hero-thematic').then(
        m => m.HeroThematicComponent,
      ),
  ],
  [
    UmpireComponentTypeEnum.SOCIAL_MEDIA,
    () =>
      import('@tisa-group/client-ui/components/social-media-post').then(
        m => m.SocialMediaPostComponent,
      ),
  ],
  [
    UmpireComponentTypeEnum.IFRAME,
    () => import('@tisa-group/client-ui/components/iframe').then(m => m.IframeComponent),
  ],
  [
    UmpireComponentTypeEnum.QUOTATION,
    () => import('@tisa-group/client-ui/components/quote').then(m => m.QuoteComponent),
  ],
  [
    UmpireComponentTypeEnum.GALLERY,
    () =>
      import('@tisa-group/client-ui/components/gallery').then(m => m.GalleryComponent),
  ],
  [
    UmpireComponentTypeEnum.IMAGE,
    () =>
      import('@tisa-group/client-ui/components/image-client').then(
        m => m.ImageClientComponent,
      ),
  ],
  [
    UmpireComponentTypeEnum.ADVERTISEMENT,
    () =>
      import('@tisa-group/client-ui/components/image-client').then(
        m => m.ImageClientComponent,
      ),
  ],
  [
    UmpireComponentTypeEnum.VIDEO,
    () =>
      import('@tisa-group/client-ui/components/video-client').then(
        m => m.VideoClientComponent,
      ),
  ],
  [
    UmpireComponentTypeEnum.SCHEDULE,
    () =>
      import('@tisa-group/client-ui/components/schedule').then(m => m.ScheduleComponent),
  ],
  [
    UmpireComponentTypeEnum.SQUAD,
    () => import('@tisa-group/client-ui/components/squad').then(m => m.SquadComponent),
  ],
  [
    UmpireComponentTypeEnum.FAQ,
    () => import('@tisa-group/client-ui/components/faq').then(m => m.FaqComponent),
  ],
  [
    UmpireComponentTypeEnum.QUIZ,
    () => import('@tisa-group/client-ui/components/quiz').then(m => m.QuizComponent),
  ],
  [
    UmpireComponentTypeEnum.SURVEY,
    () => import('@tisa-group/client-ui/components/survey').then(m => m.SurveyComponent),
  ],
]);

@Component({
  selector: 'app-umpire-component-client',
  template: `<ng-template #component></ng-template>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UmpireComponentClientComponent implements AfterViewInit {
  component = input<
    | HomePageTemplateComponent
    | TicketPageTemplateComponent
    | OttPageTemplateComponent
    | Partial<UmpireComponent<UmpireComponentType>>
  >();

  @ViewChild('component', {read: ViewContainerRef})
  readonly componentView: ViewContainerRef | undefined;

  private pendingTasks = inject(PendingTasks);

  ngAfterViewInit() {
    const componentData = this.component();
    if (componentData && this.componentView && componentData.kind) {
      this.componentView.clear();
      const componentLoader = CLIENT_COMPONENT_MAP.get(
        componentData.kind as UmpireComponentTypeEnum,
      );

      if (componentLoader) {
        const taskId = this.pendingTasks.add();

        componentLoader()
          .then(componentType => {
            const component = this.componentView!.createComponent(componentType);
            component.setInput('component', componentData);
          })
          .catch(error => {
            console.error('Failed to load component:', error);
          })
          .finally(() => {
            taskId();
          });
      }
    }
  }
}
